import React, { Component } from 'react'

import SaleProductUpdate from "components/SaleProductUpdate/SaleProductUpdate";

export default class SaleProductUpdateView extends Component {
    render() {
        return (
            <div className="fade-show">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Afiliación - Lote</h1>
                    </div>
                </div>
                <SaleProductUpdate />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/SaleProductUpdateView/SaleProductUpdateView.jsx